module.exports = __webpack_public_path__ + "img/uav-r.ef7d897c.png";